export const storeSessionInfo = (info) =>
  localStorage.setItem('3v!$$$sa.s', JSON.stringify(info));
export const getSessionInfo = () =>
  JSON.parse(localStorage.getItem('3v!$$$sa.s') || null);
export const clearSessionInfo = () => localStorage.removeItem('3v!$$$sa.s');



// WEBPACK FOOTER //
// ./src/services/JwtStore.js